import React from "react";
import { OverlayTrigger, Button, Tooltip } from "react-bootstrap";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";

const MultiLineTextArea = ({
    title = "Description",
    fieldName = "value",
    dataArray = [],
    errorArray = [],
    onChange = () => { },
    onAdd = () => { },
    onDelete = () => { },
    viewOnly,
    isLimit,
}) => (
    <div className="table-responsive">
        <table id="user_table" className="table table-bordered mb-3">
            <thead>
                <tr>
                    <th scope="col">S.No.</th>
                    <th scope="col">{title}</th>
                    {!viewOnly && <th scope="col">Remove</th>}
                </tr>
            </thead>
            <tbody>
                {Array.isArray(dataArray) && dataArray.length > 0 ? (
                    dataArray.map((x, index) => {
                        return x.deleted ? null : (
                            <tr key={index}>
                                <th>{index + 1}</th>
                                <td>
                                    {viewOnly ? (
                                        <p>{x[fieldName]}</p>
                                    ) : (
                                        <input
                                            className="form-control"
                                            name={fieldName}
                                            value={x[fieldName]}
                                            onChange={({ target: { name, value } }) => onChange({ name, value, index })}
                                        />
                                    )}
                                    <span className="small text-danger">{errorArray[index]?.[fieldName]}</span>
                                </td>
                                {!viewOnly && (
                                    <td>
                                        <div className="actionIconsGroup">
                                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}>
                                                <span className="icons pointer text-danger font-20" onClick={() => onDelete(index)}>
                                                    <FiMinusCircle />
                                                </span>
                                            </OverlayTrigger>
                                        </div>
                                    </td>
                                )}
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan="10" align="center">
                            {/* <div className="alert alert-danger d-inline-block m-0">
                                <strong>No Record</strong>
                            </div> */}
                        </td>
                    </tr>
                )}
                {((!viewOnly && isLimit && dataArray?.length !== 3) || (!viewOnly && !isLimit)) && (
                    <tr>
                        <td colSpan="10">
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Add Row</Tooltip>}>
                                <Button className="addRowPluseIcon" onClick={onAdd}>
                                    <FiPlusCircle />
                                </Button>
                            </OverlayTrigger>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    </div>
);

export default MultiLineTextArea;
